import { InjectionToken } from '@angular/core';

import { BreadcrumbConfig } from './breadcrumb.types';

export type { BreadcrumbConfig };

/**
 * Provide this token in app.config.ts to customise breadcrumb behaviour.
 * Falls back to safe defaults when not provided.
 */
export const BREADCRUMB_CONFIG = new InjectionToken<BreadcrumbConfig>('BREADCRUMB_CONFIG', {
    providedIn: 'root',
    factory: () => ({ excludedRoutes: [] }),
});

